import React from 'react';
import DOMPurify from 'dompurify';
import { useState, useContext } from 'react';
import TranslationsContext from '../TranslationsContext';

const DetailsComponent = ({ setWidgetError, setDepositedData, depositedData, currentDog, subscriptionProducts }) => {
	const t = useContext(TranslationsContext);
	const [dogWeight, setDogWeight] = useState(depositedData[currentDog].dogWeight || '');
	const [dogWeightUnit, setDogWeightUnit] = useState(depositedData[currentDog].dogWeightUnit || 'lbs');
	const [selectedProducts, setSelectedProducts] = useState(depositedData[currentDog].products || []);

	return (
		<div className="column small-12">
			<div className="row small-12 align-middle">
				<div className="field columns small-12 medium-12 flex-container flex-dir-row align-middle flex-wrap">
					<span className="field__number">1</span>
					<label htmlFor="DogWeight">{t('enter_dog_weight')}</label>
					<input
						type="number"
						id="DogWeight"
						placeholder={t('weight_placeholder')}
						name="DogWeight"
						value={dogWeight}
						min="0"
						max="500"
						onChange={(e) => {
							setDogWeight(e.target.value);
							setDepositedData((prevState) => {
								prevState[currentDog] = {
									...prevState[currentDog],
									dogWeight: e.target.value,
								};
								return prevState;
							});

							if (e.target.value !== '' && e.target.value !== '0') {
								setWidgetError('');
							}
						}}
					/>
					<div className="field__switch flex-container flex-dir-row">
						<input
							type="radio"
							id="radio-lbs"
							name="unit"
							value="lbs"
							checked={dogWeightUnit === 'lbs'}
							onChange={(e) => {
								setDogWeightUnit('lbs');
								setDepositedData((prevState) => {
									prevState[currentDog] = {
										...prevState[currentDog],
										dogWeightUnit: 'lbs',
									};
									return prevState;
								});
							}}
						/>
						<label htmlFor="radio-lbs" className="text-center">
							{t('lbs')}
						</label>
						<input
							type="radio"
							id="radio-kg"
							name="unit"
							value="kg"
							checked={dogWeightUnit === 'kg'}
							onChange={(e) => {
								setDogWeightUnit('kg');
								setDepositedData((prevState) => {
									prevState[currentDog] = {
										...prevState[currentDog],
										dogWeightUnit: 'kg',
									};
									return prevState;
								});
							}}
						/>
						<label htmlFor="radio-kg" className="text-center">
							{t('kg')}
						</label>
					</div>
				</div>
				<p className="field__description columns small-12 flex-container flex-dir-row align-middle">
					<span className="field__number">2</span> {t('select_products')}
				</p>
			</div>
			<div className={`row grid-${Object.keys(subscriptionProducts).length}`}>
				<div className="columns columns__summary">
					<div className="products-container__summary-details flex-container flex-dir-column">
						<div className="summary-details__text flex-container flex-dir-column align-center-middle">
							{selectedProducts.length < 4 && <h3 className="h5 text-center">{t('add_more_for_discount')}</h3>}
							<p>
								{t('selected_products_discount', {
									count: selectedProducts.length,
									discount: depositedData[currentDog].discount,
								})}
							</p>
						</div>
					</div>
				</div>
				{subscriptionProducts &&
					Object.keys(subscriptionProducts).map((product, index) => {
						const reviewData = window.store?.reviewsData?.[product];
						const isOutOfStock = reviewData ? reviewData.available !== 'true' : subscriptionProducts[product].fetchData?.available === false;
						const isSelectedHTML = depositedData[currentDog].products.includes(product) ? 'product-grid--selected' : '';
						const outOfStockHTML = isOutOfStock
							? `<div class="product-grid__out-of-stock">${t('temporarily_out_of_stock')}</div>`
							: '';

						return (
							<div
								key={index}
								className={`columns product-grid__wrapper ${isOutOfStock ? 'product-grid__wrapper__out-of-stock' : ''}`}
								data-handle={product}
								dangerouslySetInnerHTML={{
									__html:
										DOMPurify.sanitize(
											subscriptionProducts[product].markup_product_grid.replace(
												'product-grid--selected',
												isOutOfStock ? '' : isSelectedHTML
											)
										) + outOfStockHTML,
								}}
								onClick={(e) => {
									if (isOutOfStock) return;

									const target = e.target instanceof Element ? e.target : null;

									if (!target) return;

									const grid = target.closest('.product-grid');

									if (grid?.classList.contains('product-grid--selected')) {
										const newSelectedProducts = selectedProducts.filter((item) => item !== product);

										if (newSelectedProducts.length >= 2) {
											grid.classList.remove('product-grid--selected');
											setSelectedProducts(newSelectedProducts);
											setDepositedData((prevState) => {
												prevState[currentDog] = {
													...prevState[currentDog],
													products: newSelectedProducts,
													discount: newSelectedProducts.length * 5 > 20 ? 20 : newSelectedProducts.length * 5,
												};
												return prevState;
											});
											setWidgetError('');
										} else {
											setWidgetError(t('min_two_products'));
										}
									} else {
										grid?.classList.add('product-grid--selected');
										setWidgetError('');
										setSelectedProducts([...selectedProducts, product]);
										setDepositedData((prevState) => {
											prevState[currentDog] = {
												...prevState[currentDog],
												products: [...selectedProducts, product],
												discount:
													[...selectedProducts, product].length * 5 > 20 ? 20 : [...selectedProducts, product].length * 5,
											};
											return prevState;
										});
									}
								}}
							></div>
						);
					})}
			</div>
		</div>
	);
};

export default DetailsComponent;
